import { SyncConfig, withStorageSync } from '@ngrx-toolkit/core';
import { EmptyFeatureResult, SignalStoreFeature, SignalStoreFeatureResult } from '@ngrx/signals';

type SyncMethods = {
  clearStorage(): void;
  readFromStorage(): void;
  writeToStorage(): void;
};
type SyncFeatureResult = EmptyFeatureResult & {
  methods: SyncMethods;
};

export function withConditionalStorageSync<Input extends SignalStoreFeatureResult>(
  config: SyncConfig<Input['state']>
): SignalStoreFeature<Input, SyncFeatureResult> {
  try {
    const isOff = typeof localStorage !== 'undefined' && localStorage.getItem('davinci.storage-sync') === 'off';

    return isOff ? (store: any) => store : withStorageSync(config);
  } catch {
    return withStorageSync(config);
  }
}
